import { configureStore } from "@reduxjs/toolkit";

import compareReducer from "@/pages/compare/compareSlice";
import planReducer from "@/pages/plan/planSlice";
import resultsReducer from "@/pages/results_v2/resultsSlice";

export default configureStore({
  reducer: {
    results: resultsReducer,
    compare: compareReducer,
    plan: planReducer,
  },
});
